import React, { useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import { CaretLeft } from "@phosphor-icons/react";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		backgroundColor: theme.mode === "light" ? "#FEFEFF" : "#0b0b0d",
		flex: "none",
		padding: 0,
		alignItems: "center",
		minHeight: "100px",
		"& .MuiCardHeader-title": {
			fontSize: "13px",
			fontWeight: 600,
		},
		"& .MuiCardHeader-subheader": {
			fontSize: "11px",
		}
	},
	backButton: {
		minWidth: "25px",
		width: "25px",
		padding: 0,
		marginRight: "8px",
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button color="primary" className={classes.backButton} onClick={handleBack}>
						<CaretLeft size={24} weight="bold" />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
